import { pdf } from "@progress/kendo-drawing";

export const PDF_REPORT_FONT_FAMILY = "Noto Sans";

let isPdfFontConfigured = false;

export const ensurePdfFonts = () => {
  if (isPdfFontConfigured || typeof window === "undefined") return;

  const fontBasePath =
    "https://cdn.jsdelivr.net/gh/googlefonts/noto-fonts@main/hinted/ttf/NotoSans";
  const regular = `${fontBasePath}/NotoSans-Regular.ttf`;
  const bold = `${fontBasePath}/NotoSans-Bold.ttf`;
  const italic = `${fontBasePath}/NotoSans-Italic.ttf`;
  const boldItalic = `${fontBasePath}/NotoSans-BoldItalic.ttf`;

  pdf.defineFont({
    [PDF_REPORT_FONT_FAMILY]: regular,
    [`${PDF_REPORT_FONT_FAMILY}|Bold`]: bold,
    [`${PDF_REPORT_FONT_FAMILY}|Italic`]: italic,
    [`${PDF_REPORT_FONT_FAMILY}|Bold|Italic`]: boldItalic,
    Roboto: regular,
    "Roboto|Bold": bold,
    "Roboto|Italic": italic,
    "Roboto|Bold|Italic": boldItalic,
    Arial: regular,
    "Arial|Bold": bold,
    "Arial|Italic": italic,
    "Arial|Bold|Italic": boldItalic,
    "sans-serif": regular,
    "sans-serif|Bold": bold,
    "sans-serif|Italic": italic,
    "sans-serif|Bold|Italic": boldItalic,
  });

  isPdfFontConfigured = true;
};
